export default __webpack_public_path__ + "static/media/architecture2.7b747dd6.jpg";